export const VENDOR_REGISTER_REQUEST = 'VENDOR_REGISTER_REQUEST'
export const VENDOR_REGISTER_SUCCESS = 'VENDOR_REGISTER_SUCCESS'
export const VENDOR_REGISTER_FAIL = 'VENDOR_REGISTER_FAIL'
export const VENDOR_REGISTER_RESET = 'VENDOR_REGISTER_RESET'
